import { render, staticRenderFns } from "./GLTrialBalance.vue?vue&type=template&id=0ecc35bc"
import script from "./GLTrialBalance.vue?vue&type=script&lang=js"
export * from "./GLTrialBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports